import getSDK, { SDK } from "@ua/web-sdk"
import React from "react"

type Props = {
  embeddedId: string
  width: string
  height: string
}

const EmbeddedContainer: React.FC<Props> = ({ embeddedId, width, height }) => {
  const [sdk, setSDK] = React.useState<SDK | null>(null)
  React.useEffect(() => {
    getSDK().then(setSDK)
  })

  const ref: React.MutableRefObject<HTMLDivElement | null> = React.useRef(null)

  React.useEffect(() => {
    if (sdk && sdk.components.embeddedViews && ref.current) {
      const view = sdk.components.embeddedViews.create(ref.current, embeddedId)
      return () => {
        view.destroy()
      }
    }
  }, [embeddedId, sdk])

  return <div ref={ref} style={{ height, width }} />
}

export default EmbeddedContainer
